module.exports = __webpack_public_path__ + "img/signature-sample-bg_en.b58543e4.png";